module.exports = __webpack_public_path__ + "static/media/book-h2o.63c6eae7.jpg";